// Centralized config for the static "create assessment from template" link (PFM-2545).
// Keeping the URL shape in one place means the admin copy-link button and the
// authenticated route definition can never drift apart.

// Static, shareable link that drops a logged-in user into the create-from-template
// flow for a specific assessment-templates resource id.
//   /reports/create/:templateId
// :templateId is the assessment-templates resource id (confirmed by product owner).
export const CREATE_FROM_TEMPLATE_PATH = '/reports/create/:templateId';

// Where both failure cases land (AC#4): the assessments list.
export const ASSESSMENTS_LIST_PATH = '/reports/list';

// Build the relative app path for a given template id. Pair with the route above.
export const buildCreateFromTemplatePath = (templateId) => {
  if (templateId === undefined || templateId === null || templateId === '') return null;
  return `/reports/create/${encodeURIComponent(templateId)}`;
};

// Build the full, copyable/shareable URL (origin + path) for the admin copy button.
export const buildCreateFromTemplateUrl = (templateId, origin) => {
  const path = buildCreateFromTemplatePath(templateId);
  if (!path) return null;
  const base = origin || (typeof window !== 'undefined' ? window.location.origin : '');
  return `${base}${path}`;
};
